import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { Cookies } from "react-cookie";
import AxiosInstance from "../../components/common/authservice/auth";
import { API_KEY } from "../../environment";

export const societyUsersGraph = createAsyncThunk("societyUsersGraph", async () => {
  try {
    const cookies = new Cookies();
    const token = cookies.get("token");

    const response = await AxiosInstance.get(
      `${API_KEY}/api/dashboard/chart/user-stats`, 
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        "Content-Type": "application/json",
       
      }
    );

    return response.data;
  } catch (error) {
    if (error.response) {
      throw error.response.data.message;
    } else {
      throw error;
    }
  }
});

const initialState = {
  isLoading: false,
  societyUsersGraphData: null,
  isError: false,
  errorMessage: "",
};

const societyUsersGraphSlice = createSlice({
  name: "societyUsersGraph",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(societyUsersGraph.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(societyUsersGraph.fulfilled, (state, action) => {
      state.isLoading = false;
      state.societyUsersGraphData = action.payload;
    });
    builder.addCase(societyUsersGraph.rejected, (state, action) => {
      state.isLoading = false;
      state.isError = true;
      state.errorMessage = action.error.message;
    });
  },
});

export default societyUsersGraphSlice.reducer;
